<template lang="pug">
.relative-position(ref="top")
    .relative-position
        .row(v-if="loading")
            search-vertical-skeleton(v-if="!isVertical")
            product-slider-skeleton-desktop.q-mb-md(
                v-else
                v-for="i in 3"
                :key="i"
                :countSlides="slidesCount"
            )
        .row(v-else)
            template(v-for="(product, index) in products")
                .q-pb-md.product-card(
                    v-if="isVertical"
                    :class="`product-card-${isActivAccessibility ? 2 : countPerRow}`")
                    preview-desktop(
                        :data="product"
                        :topOffset="!index"
                        :country="true"
                        :marketing="marketing"
                        @showAnalogsList="showAnalogsList")
                search-preview-desktop.q-pb-md(
                    v-else
                    :data="product"
                    :country="true"
                    marketing
                    @showAnalogsList="showAnalogsList")
    .row(v-if="products.length && totalCount > limit")
            base-btn.float-right.q-mt-md(
                label="Показать ещё"
                font_size="16"
                backgroundHEX="#EEF7F1"
                text_color="positive"
                :loading="showMoreLoading"
                @click="showMore"
                v-if="pageNumber < paginationCount")
    .flex.flex-start.justify-center.pagination-block(v-if="products.length && totalCount > limit")
        q-btn.float-right.text-weight-medium.font-16.pagination-button.pagination-button-prev(
            flat
            color="positive"
            @click="prevPage"
            v-if="pageNumber > 1") Назад
        q-pagination.pagination(
            flat
            color="primary"
            active-color="positive"
            :min="1"
            :max-pages="10"
            :max="paginationCount"
            :model-value="pageNumber"
            @update:model-value="setPagination")
        q-btn.float-right.text-weight-medium.font-16.pagination-button(
            flat
            color="positive"
            @click="nextPage"
            v-if="pageNumber < paginationCount") Далее
analogs-desktop(
    :showAnalogsDialog="showAnalogsDialog"
    @closeAnalogsDialog="closeAnalogsDialog"
)
</template>

<script>
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import PreviewDesktop from 'components/Preview/PreviewDesktop.vue';
import SearchPreviewDesktop from 'src/components/SearchPreview/SearchPreviewDesktop.vue';
import BaseSpiner from 'components/Base/BaseSpiner.vue';
import BaseBtn from 'components/Base/BaseBtn.vue';
import SearchVerticalSkeleton from 'components/Search/SearchVerticalSkeleton.vue';
import ProductSliderSkeletonDesktop from 'components/ProductSlider/ProductSliderSkeletonDesktop.vue';

import AnalogsDesktop from '../Analogs/AnalogsDesktop.vue';

export default {
    name: 'ProductListDesktop',
    props: {
        products: {
            type: Array,
            required: true,
        },
        totalCount: {
            type: Number,
            required: true,
        },
        emptyList: {
            type: Boolean,
            default: false,
        },
        showMoreLoading: {
            type: Boolean,
            default: false,
        },
        isVertical: {
            type: Boolean,
        },
        countPerRow: {
            type: Number,
            default: () => 4,
        },
        loading: {
            type: Boolean,
            default: () => false,
        },
        page: {
            type: Number,
        },
        marketing: {
            type: Boolean,
            default: () => false,
        },
    },
    components: {
        PreviewDesktop,
        SearchPreviewDesktop,
        BaseSpiner,
        BaseBtn,
        SearchVerticalSkeleton,
        ProductSliderSkeletonDesktop,
        AnalogsDesktop,
    },
    setup(props, { emit }) {
        const store = useStore();
        const route = useRoute();
        const router = useRouter();

        const showAnalogsDialog = ref(false);

        const isActivAccessibility = computed(() => store.getters['styles/isActiv']);

        const limit = computed(() => route.query.limit || 20);

        const pageNumber = computed(() => props.page || parseInt(route.query.page) || 1);
        const paginationCount = computed(() => Math.ceil(props.totalCount / limit.value));
        const slidesCount = computed(() => {
            if (process.env.CLIENT) {
                if (window.innerWidth >= '1280') {
                    return 4;
                } else if (window.innerWidth >= '960') {
                    return 3;
                } else {
                    return 2;
                }
            }
            return 4;
        });

        const analogs = computed(() => store.getters['products/PRODUCT_ANALOGS']);

        const setPagination = (page, showMore = false) => {
            emit('setPagination', {
                page,
                letsShowMore: showMore,
            });
        };

        const nextPage = () => {
            setPagination(pageNumber.value + 1);
        };

        const prevPage = () => {
            setPagination(pageNumber.value - 1);
        };

        const showMore = () => {
            setPagination(pageNumber.value + 1, true);
        };

        const showAnalogsList = () => {
            showAnalogsDialog.value = true;
        };

        const closeAnalogsDialog = () => {
            showAnalogsDialog.value = false;
        };

        return {
            limit,
            nextPage,
            prevPage,
            showMore,
            pageNumber,
            slidesCount,
            setPagination,
            paginationCount,
            isActivAccessibility,
            analogs,
            showAnalogsList,
            showAnalogsDialog,
            closeAnalogsDialog,
        };
    },
};
</script>

<style lang="scss" scoped>
.pagination-block {
    margin: 18px 0;
}

.pagination :deep {
     .q-btn {
         font-weight: 600;
         width: 33px;
         height: 33px;
         border-radius: 4px;
         box-shadow: none;
         margin-right: 16px;

         @media(max-width: 960px) {
             width: 30px;
             height: 30px;
         }
    }

    .text-positive {
        color: $secondary !important;
        background-color: $positive;
    }

    .q-btn__wrapper {
        &::before {
            box-shadow: none !important;
        }
    }
}

.pagintion-dotted {
    color: $primary !important;
    font-weight: 600;
    width: 33px;
    height: 33px;
    letter-spacing: 2px;
}

.pagination-button :deep {
    text-transform: none;
    background: $accent;
    width: 110px;
    height: 33px;

    .q-btn__wrapper {
        min-height: 0;
    }
}

.pagination-button-prev {
    margin-right: 16px;
}

.product-card {
    padding-left: 8px;
    padding-right: 8px;
    box-sizing: border-box;

    &-2 {
        width: 50%;

        &:first-child,
        &:nth-child(4n + 5) {
            padding-left: 0;

            @media (max-width: 1280px) {
                padding-left: 8px;
            }
        }

        &:nth-child(4n + 4) {
            padding-right: 0;

            @media screen and (max-width: 1280px) {
                padding-right: 8px;
            }
        }
    }

    &-4 {
        width: 25%;

        @media (max-width: 1280px) {
            width: 33%;
        }
        @media (max-width: 960px) {
            width: 50%;
        }

        &:first-child,
        &:nth-child(4n + 5) {
            padding-left: 0;

            @media (max-width: 1280px) {
                padding-left: 8px;
            }
        }

        &:nth-child(4n + 4) {
            padding-right: 0;

            @media screen and (max-width: 1280px) {
                padding-right: 8px;
            }
        }
    }

    &-5 {
        width: 20%;

        &:first-child,
        &:nth-child(5n + 6) {
            padding-left: 0;
        }

        &:nth-child(5n + 5) {
            padding-right: 0;
        }
    }
}
</style>
